module.exports = __webpack_public_path__ + "img/volume_mute.8684ae30.svg";